import type { Booking, Inquiry, LeadSummary } from '../api/types';

// Anzeigenamen für Portale, Zuordnungsgründe und Stände (Microsoft Bookings, Immobilienanfragen).

export const portalLabels: Record<string, string> = {
  IMMOSCOUT24: 'ImmoScout24',
  IMMOWELT: 'Immowelt',
  IMMONET: 'Immonet',
  KLEINANZEIGEN: 'Kleinanzeigen',
  MEINESTADT: 'meinestadt.de',
  OTHER: 'Portal',
};

export function sourceLabel(q: Pick<Inquiry, 'portal'>): string {
  return q.portal ? (portalLabels[q.portal] ?? q.portal) : 'Direkte Anfrage';
}

export const matchedByLabels: Record<string, string> = {
  PLUS_ADDRESS: 'über die Objektadresse (Plus-Adresse)',
  OBJECT_NUMBER: 'über die Objektnummer',
  PORTAL_REF: 'über die bekannte Portal-Objekt-ID',
  ADDRESS: 'über die Anschrift',
  MANUAL: 'vom Support zugeordnet',
};

export const bookingReasons: Record<string, string> = {
  NO_MATCH: 'Kein Lead mit dieser E-Mail-Adresse oder Telefonnummer – vermutlich ein neuer Kunde.',
  AMBIGUOUS: 'Mehrere Leads passen – bitte den richtigen wählen.',
  NO_CONTACT_DATA: 'Die Buchung enthält weder E-Mail-Adresse noch Telefonnummer.',
  CREATE_FAILED: 'Ein Lead passt, der Termin ließ sich aber nicht automatisch anlegen.',
  SINGLE_LEAD: 'Eindeutig über E-Mail bzw. Telefonnummer zugeordnet.',
  CONTACT_LEAD: 'Über einen Kontakt des Leads zugeordnet.',
  ASSIGNED_BY_SUPPORT: 'Vom Support zugeordnet.',
};

export function bookingReason(b: Booking): string {
  const reason = typeof b.match_details.reason === 'string' ? b.match_details.reason : '';
  return bookingReasons[reason] ?? '';
}

export function leadLabel(l: Pick<LeadSummary, 'company_name' | 'first_name' | 'last_name' | 'street' | 'house_number' | 'postal_code' | 'city' | 'phone'>): string {
  const name = l.company_name || [l.first_name, l.last_name].filter(Boolean).join(' ') || 'Lead';
  const address = [[l.street, l.house_number].filter(Boolean).join(' '), [l.postal_code, l.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return [name, address, l.phone].filter(Boolean).join(' · ');
}
